import { getLocaleStrings, getCurrentLanguage } from 'components/contexts/LocalizationContext';
import LocalizationKey from './LocalizationKey';
import moment from 'moment';
import 'moment/locale/fi';

export type LanguageCode = 'en' | 'fi';

export const DisplayLanguages: { [lang: string]: string } = {
	'en': 'English',
	'fi': 'Suomi'
};

export function isSupportedLanguage(language: string | null | undefined) {
	if (typeof language !== 'string')
		return false;

	let lang = language.substr(0, 2);

	// if(lang === 'no')
	// 	lang = 'nn';

	return lang === 'en' || lang === 'fi';
}

class Localization {

	public get(key: LocalizationKey): string {
		return getLocaleStrings()[key] || key;
	}

	public getAvailableLanguageCodes(): LanguageCode[] {
		return ['en', 'fi'];
	}

	public format(key: LocalizationKey, ...params: string[]): string {
		let str = this.get(key);

		let i = 0;
		for (let p of params) {
			if (p !== undefined && p !== null)
				str = str.replace('{' + i + '}', p);

			++i;
		}

		return str;
	}

	public getPageTitle(...keys: LocalizationKey[]): string {
		let title = '';

		for (let key of keys) {
			if (title.length === 0) {
				title = title.concat(this.get(key as LocalizationKey));
			}
			else {
				title = title.concat(' - ', this.get(key as LocalizationKey));
			}
		}

		return title.concat(' | ', this.get('home_title'));
	}

	public getPageTitleText(...texts: string[]): string {
		let title = '';

		for (let text of texts) {
			if (title.length === 0) {
				title = title.concat(text);
			}
			else {
				title = title.concat(' - ', text);
			}
		}

		return title.concat(' | ', this.get('home_title'));
	}

	public getLocalizedMoment(inp?: moment.MomentInput): moment.Moment {
		let localMoment = moment(inp);
		let lang = getCurrentLanguage();
		localMoment.locale(lang);
		return localMoment;
	}


	public fallback: LanguageCode = 'en';
}

const Locale = new Localization();
export default Locale;
